// src/pages/beta-community/components/TimelineSection.jsx
import React from 'react';

const TimelineSection = () => {
  const steps = [
    {
      number: '01',
      title: 'Présentez votre profil',
      description: 'Répondez simplement "OUI" par email ou remplissez le formulaire ci-dessous. Places limitées, attribution par ordre d\'arrivée.'
    },
    {
      number: '02',
      title: 'Échange de cadrage',
      description: 'Un échange court permet de vérifier le bon parcours bêta, le plan adapté et les fonctionnalités réellement utiles pour vous.'
    },
    {
      number: '03',
      title: 'Accord de participation',
      description: 'Un accord précise la confidentialité, les conditions bêta, la propriété des données et le rythme de feedback attendu.'
    },
    {
      number: '04',
      title: 'Onboarding guidé',
      description: 'Création du compte, première prise en main et accompagnement selon votre profil : collectionneur, Art Advisor ou Family Office / CGP.'
    }
  ];

  return (
    <section className="section timeline-section">
      <div className="container">
        <h2 className="section-title">Comment ça marche ?</h2>
        
        <div className="timeline">
          {steps.map((step, index) => (
            <div
              key={index}
              className="timeline-item"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="timeline-dot"></div>
              <div className="timeline-content">
                <div className="timeline-number">{step.number}</div>
                <h3 className="timeline-title">{step.title}</h3>
                <p className="timeline-desc">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TimelineSection;